module.exports = __webpack_public_path__ + "static/img/Lachie-Whitfield.f88dc5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie-Whitfield.jpg
// module id = vvtw
// module chunks = 0